import { AboutUsModel } from './about-us-model';
import { CircleFeatureModel } from './circle-feature-model';
import { DropDownListModel } from './drop-down-link-model';
import { EmployeeBoxModel } from './employee-box-model';
import { InternalLinkModel } from './internal-link-model';
import { OurTeamModel } from './our-team-model';
import { PromoSectionModel } from './promo-section-model';
import { SEOBoxModel } from './seo-model';
import { ImageTitleDescriptionModel } from './image-title-description-model';
import { CarouselOfItemsModel } from './carousel-of-items-model';
import { CarouselOfImagesModel } from './carousel-of-images-model';
import { ItemsInRowModel } from './items-in-row-model';
import { EmployeesCollectionModel } from './employees-collection-model';
import { ThreeColumnGridModel } from './three-column-grid-model';
import { FourGridColumnModel } from './four-column-grid-model';
import { ButtonModel } from './button-model';
import { PageSectionModel } from './page-section-model';
import { TextModel } from './text-model';
import { TextFeatureWithDescription } from './text-feature-with-description-model';
import { ImageFeatureWithLink } from './image-feature-with-link-model';
import { BlogArticlesListModel } from './blog-articles-list.model';
import { BlogArticleModel } from './blog-article.model';
import { ImageWithTextModel } from './image-with-text-model';
import { HeroWithVideoModel } from './hero-with-video-model';
import { OfficeModel } from './office-model';
import { ExternalLinkModel } from './external-link-model';
import { OpinionModel } from './opinion-model';
import { TabsMenuModel } from './tabs-menu-model';
import { NavTabTextItemModel } from './nav-tab-text-item-model';
import { TabContentItemModel } from './tab-content-item-model';
import { ArchLineSectionModel } from './arch-line-section.model';
import { QuoteWithImageModel } from './quote-with-image.model';
import { ProgressStepsModel } from './progress-steps-model';
import { GridModel } from './grid-model';
import { AwardWithStarsAndImageModel } from './award-with-stars-and-image-model';
import { ImageWithButtonModel } from './image-with-button';
import { InputTextModel } from './input-text-model';
import { AccordionModel } from './accordion-model';
import { LatestArticlesModel } from './latest-articles-model';
import { FooterLinksColumnModel } from './footer-links-column-model';
import { FooterModel } from './footer-model';
import { SocialMediaPanelModel } from './social-media-panel-model';
import { OurTeamPhotosLinkModel } from './our-team-photos-link-model';
import { ProcessIconsModel } from './process-icons-model';
import { StaticPageJumbotronModel } from './static-page-jumbotron-model';
import { IconWithTextSectionModel } from './icon-with-text-section-model';
import { SectionHeaderModel } from './section-header-model';
import { MainHeroModel } from './main-hero-model';
import { TwoColumnGridModel } from './two-column-grid-model';
import { LinkBoxModel } from './link-box-model';
import { CaseStudyListModel } from './case-study-list-model';
import { CaseStudyListItemModel } from './case-study-list-item-model';
import { CaseStudyArticleModel } from './case-study-article-model';
import { CategoryModel } from './category-model';
import { IconHeaderModel } from './icon-header';
import { ChapterModel } from './chapter-model';
import { ArticleParagraphModel } from './article-paragraph';
import { SideNavSliderModel } from './side-nav-slider-model';
import { BlogHeroModel } from './blog-hero-model';
import { TextBlockSchemaModel } from './text-block-schema-model';
import { QuoteModel } from './quote-model';
import { ContactEmployeeModel } from './contact-employee-model';
import { CaseStudyNextModel } from './case-study-next-model';
import { LatestCaseStudiesModel } from './latest-case-studies-model';
import { FeaturedArticlesModel } from './featured-articles-model';
import { TwoColorSectionWithImageModel } from './two-color-section-with-image-model';
import { DownloadWithImageModel } from './download-with-image-model';
import { TextWithImageOutsideModel } from './text-with-image-outside-model';
import { BlogAuthorListModel } from './blog-authors-list-model';
import { PageBackLinkModel } from './page-back-link-model';
import { IconWithDescriptionModel } from './icon-with-description-model';
import { AwardModel } from './award-model';
import { CareerHeroModel } from './career-hero-model';
import { ActiveJobOffertsModel } from './active-job-offerts-model';
import { ProcessBoxesModel } from './process-boxes-model';
import { StickySectionsWrapperModel } from './sticky-sections-wrapper-model';
import { TextEmailButtonFormModel } from './text-email-button-model';
import { VideoListModel } from './video-list-model';
import { FormComponentModel } from './form-component-model';
import { CtaButtonModel } from './cta-button';
import { HighlightedFieldModel } from './highlighted-field-model';
import { EmbededdedVideoModel } from './embededded-video-model';
import { JobOffertSeoModel } from './job-offert-seo.model';

export const Models = {
  CircleFeatureModel,
  EmployeeBoxModel,
  PromoSectionModel,
  InternalLinkModel,
  DropDownListModel,
  SEOBoxModel,
  OurTeamModel,
  ImageTitleDescriptionModel,
  CarouselOfItemsModel,
  CarouselOfImagesModel,
  ItemsInRowModel,
  ThreeColumnGridModel,
  FourGridColumnModel,
  EmployeesCollectionModel,
  ButtonModel,
  PageSectionModel,
  TextModel,
  TextFeatureWithDescription,
  ImageFeatureWithLink,
  BlogArticlesListModel,
  BlogArticleModel,
  AboutUsModel,
  ImageWithTextModel,
  HeroWithVideoModel,
  OfficeModel,
  ExternalLinkModel,
  OpinionModel,
  QuoteWithImageModel,
  ProgressStepsModel,
  GridModel,
  AwardWithStarsAndImageModel,
  TabsMenuModel,
  NavTabTextItemModel,
  TabContentItemModel,
  ArchLineSectionModel,
  ImageWithButtonModel,
  InputTextModel,
  AccordionModel,
  LatestArticlesModel,
  FooterLinksColumnModel,
  FooterModel,
  SocialMediaPanelModel,
  OurTeamPhotosLinkModel,
  ProcessIconsModel,
  StaticPageJumbotronModel,
  IconWithTextSectionModel,
  SectionHeaderModel,
  MainHeroModel,
  TwoColumnGridModel,
  LinkBoxModel,
  SideNavSliderModel,
  BlogHeroModel,
  CaseStudyListModel,
  CaseStudyArticleModel,
  CategoryModel,
  CaseStudyListItemModel,
  IconHeaderModel,
  ArticleParagraphModel,
  TextBlockSchemaModel,
  QuoteModel,
  ContactEmployeeModel,
  CaseStudyNextModel,
  LatestCaseStudiesModel,
  FeaturedArticlesModel,
  TwoColorSectionWithImageModel,
  DownloadWithImageModel,
  TextWithImageOutsideModel,
  BlogAuthorListModel,
  PageBackLinkModel,
  IconWithDescriptionModel,
  AwardModel,
  CareerHeroModel,
  ActiveJobOffertsModel,
  ProcessBoxesModel,
  StickySectionsWrapperModel,
  TextEmailButtonFormModel,
  ChapterModel,
  VideoListModel,
  FormComponentModel,
  CtaButtonModel,
  HighlightedFieldModel,
  EmbededdedVideoModel,
  JobOffertSeoModel
};
